import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@redux-devtools/ui';
import { MdAvTimer } from 'react-icons/md';
import { toggleSlider } from '../../actions/index.js';
class SliderButton extends Component {
    shouldComponentUpdate(nextProps) {
        return nextProps.isOpen !== this.props.isOpen;
    }
    render() {
        return (React.createElement(Button, { mark: this.props.isOpen && 'base0D', title: this.props.isOpen ? 'Hide slider' : 'Show slider', tooltipPosition: "top-left", onClick: this.props.toggleSlider },
            React.createElement(MdAvTimer, null)));
    }
}
const actionCreators = {
    toggleSlider,
};
export default connect(null, actionCreators)(SliderButton);
